export default "__VITE_ASSET__BlZjBIJ9__"